import { MfaPhoneScreen } from "@/interactors/MfaPhoneScreen";

export default function MfaPhonePage() {
  return <MfaPhoneScreen />;
}
